// Central reward thresholds shared with backend
// Keep in sync with backend/exams/reward_config.py
// Each entry: [minimumPercent, stars]
export const STAR_THRESHOLDS = [
  [40, 1], // 1★ for 40% – <60%
  [60, 2], // 2★ for 60% – <80%
  [80, 3], // 3★ for 80% – <90%
  [90, 4], // 4★ for 90% – <95%
  [95, 5], // 5★ for ≥95%
];
